export enum WorkspacesPlatformAccessOperation {
    create = "9a8ade4e-07a5-42ce-94c0-5ad108f0eaee",
    read = "81a2e0a4-f06e-4e56-94ae-1fa5cc2566bf",
    update = "fdbcf018-0b6d-48c5-9343-a14f445fb4cc",
    delete = "e9e58dc8-a0ea-4a58-bf19-a975ff641208",
}
